export const NORMALISED_ERRORS = [
  {
    matchMessages: ['Failure to update settings to api'],
    id: 'error_messages.issue_updating_settings',
    defaultMessage:
      'There has been an issue updating your settings. Please try again and contact support if the problem persists.'
  },
  {
    matchMessages: ['Failed to fetch import Google sheet information'],
    id: 'error_messages.issue_retrieving_google_sheet_information',
    defaultMessage:
      'There has been an issue retrieving your sheet info. Please try again and contact support if the problem persists.'
  },
  {
    matchMessages: ['Failure to get accounts from api'],
    id: 'error_messages.issue_retrieving_chart_of_accounts',
    defaultMessage:
      'There has been an issue retrieving your chart of accounts. Please try again and contact support if the problem persists.'
  },
  {
    matchMessages: ['Failure to get settings from api'],
    id: 'error_messages.issue_retrieving_settings',
    defaultMessage:
      'There has been an issue retrieving your settings. Please try again and contact support if the problem persists.'
  },
  {
    matchMessages: ['Failure to fetch VAT deferral by id'],
    id: 'error_messages.issue_retrieving_vat_deferral',
    defaultMessage:
      'There has been an issue retrieving your VAT/GST deferral. Please try again and contact support if the problem persists.'
  },
  {
    matchMessages: ['Forecast id missing for VAT deferral tile'],
    id: 'error_messages.issue_vat_deferral',
    defaultMessage:
      'There has been an issue with your VAT/GST deferral. Please try again and contact support if the problem persists.'
  },
  {
    matchMessages: ['Failure to create / update VAT deferral'],
    id: 'error_messages.issue_updating_vat_deferral',
    defaultMessage:
      'There has been an issue creating/updating your VAT/GST deferral. Please try again and contact support if the problem persists.'
  },
  {
    matchMessages: ['Failure to delete VAT deferral'],
    id: 'error_messages.issue_deleting_vat_deferral',
    defaultMessage:
      'There has been an issue removing your VAT/GST deferral. Please try again and contact support if the problem persists.'
  },
  {
    matchMessages: ['Fail to fetch next VAT payment'],
    id: 'error_messages.issue_retrieving_vat_payment',
    defaultMessage:
      'There has been an issue retrieving your next VAT/GST payment. Please try again and contact support if the problem persists.'
  },
  {
    matchMessages: ['Failed to update row'],
    id: 'error_messages.issue_updating_invoice',
    defaultMessage:
      'There has been an issue updating this invoice. Please try again and contact support if the problem persists.'
  },
  {
    matchMessages: ['Failed to fetch invoice data'],
    id: 'error_messages.issue_retrieving_invoice',
    defaultMessage:
      'There has been an issue retrieving your invoice data. Please try again and contact support if the problem persists.'
  },
  {
    matchMessages: ['Failed to update account category groups'],
    id: 'error_messages.issue_reordering_grouping_accounts',
    defaultMessage:
      'There has been an issue with reordering and grouping your accounts. Please try again and contact support if the problem persists.'
  },
  {
    matchMessages: ['Missing params for updating group row'],
    id: 'error_messages.issue_updating_grouped_account',
    defaultMessage:
      'There has been an issue with updating one of your account groups. Please try again and contact support if the problem persists.'
  },
  {
    matchMessages: ['Missing params for deleting group row'],
    id: 'error_messages.issue_removing_grouped_account',
    defaultMessage:
      'There has been an issue with removing one of your account groups. Please try again and contact support if the problem persists.'
  },
  {
    matchMessages: ['Missing params for renaming group row'],
    id: 'error_messages.issue_renaming_grouped_account',
    defaultMessage:
      'There has been an issue with renaming one of your account groups. Please try again and contact support if the problem persists.'
  },
  {
    matchMessages: ['Missed forecast in order to build the row'],
    id: 'error_messages.issue_loading_forecast',
    defaultMessage:
      'There has been an error loading your forecast. Please try again and contact support if the problem persists.'
  },
  {
    matchMessages: ['Missing parameters for updatePredictionAndPaymentType'],
    id: 'error_messages.issue_updating_header_rows',
    defaultMessage:
      'There has been an issue updating your header rows. Please try again and contact support if the problem persists.'
  },
  {
    matchMessages: [
      'Failed to update the prediction data',
      'Missing forecast or report required to render HeaderRowAccount'
    ],
    id: 'error_messages.issue_calculating_numbers',
    defaultMessage:
      'There has been an issue calculating some of your numbers. Please try again and contact support if the problem persists.'
  },
  {
    matchMessages: ['Failed to get TNE'],
    id: 'error_messages.issue_retrieving_explanation',
    defaultMessage:
      'There has been an issue retrieving this explanation. Please try again and contact support if the problem persists.'
  },
  {
    matchMessages: ['Failed to get next VAT payment'],
    id: 'error_messages.issue_displaying_vat_payment',
    defaultMessage:
      'There has been an issue displaying your next VAT payment. Please try again and contact support if the problem persists.'
  },
  {
    matchMessages: ['Failed to get forecast'],
    id: 'error_messages.issue_displaying_forecast',
    defaultMessage:
      'There has been an issue displaying your forecast. Please try again and contact support if the problem persists.'
  },
  {
    matchMessages: ['Failed to get customers and suppliers details'],
    id: 'error_messages.issue_displaying_customers_suppliers_details',
    defaultMessage:
      'There has been an issue displaying customer/supplier details. Please try again and contact support if the problem persists.'
  },
  {
    matchMessages: ['Failed to fetch report'],
    id: 'error_messages.issue_displaying_report',
    defaultMessage:
      'There has been an issue displaying your report. Please try again and contact support if the problem persists.'
  },
  {
    matchMessages: ['Failed to fetch category account groups'],
    id: 'error_messages.issue_displaying_account_categories',
    defaultMessage:
      'There has been an issue displaying your account categories. Please try again and contact support if the problem persists.'
  },
  {
    matchMessages: ['Failed to update category account groups'],
    id: 'error_messages.issue_updating_account_categories',
    defaultMessage:
      'There has been an issue updating your account categories. Please try again and contact support if the problem persists.'
  },
  {
    matchMessages: ['Failed to update forecast'],
    id: 'error_messages.issue_updating_forecast',
    defaultMessage:
      'There has been an issue updating your forecast. Please try again and contact support if the problem persists.'
  },
  {
    matchMessages: ['Failed to update payment type or prediction'],
    id: 'error_messages.issue_updating_prediction',
    defaultMessage:
      'There has been an issue updating your prediction. Please try again and contact support if the problem persists.'
  },
  {
    matchMessages: ['Failed to fetch prediction or payment type'],
    id: 'error_messages.issue_displaying_prediction',
    defaultMessage:
      'There has been an issue displaying your prediction. Please try again and contact support if the problem persists.'
  },
  {
    matchMessages: ['Failed to create driver group'],
    id: 'error_messages.create_driver_group_failure',
    defaultMessage:
      'There has been an issue while creating your driver group. Please try again and contact support if the problem persists.'
  },
  {
    matchMessages: ['Failed to update driver group'],
    id: 'error_messages.create_driver_group_failure',
    defaultMessage:
      'There has been an issue while updating your driver group. Please try again and contact support if the problem persists.'
  },
  {
    matchMessages: ['Failed to save driver'],
    id: 'error_messages.save_driver_failure',
    defaultMessage:
      'There has been an issue while saving your driver. Please try again and contact support if the problem persists.'
  },
  {
    matchMessages: ['Failed to delete driver'],
    id: 'error_messages.delete_driver_failure',
    defaultMessage:
      'There has been an issue while deleting your driver. Please try again and contact support if the problem persists.'
  }
];

export const findNormalisedErrorByMessage = (error: Error) => {
  if (!error.message) {
    return;
  }

  return NORMALISED_ERRORS.find(e =>
    e.matchMessages.some(message =>
      message.trim().toLocaleLowerCase().includes(error.message.trim().toLocaleLowerCase())
    )
  );
};
